import * as React from 'react';
import styled from 'styled-components';

import { IconCourseSearch } from '@doltech/icons/IconCourseSearch';
import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { colorsV2 } from '../../colors-v2';
import cl from 'classnames';

const ButtonIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.1s ease-out;

  &:hover {
    background-color: ${colorsV2.gray10};
    transition: all 0.2s ease-out;
  }

  &:focus {
    background-color: ${colorsV2.gray20};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;

  > *:first-child {
    margin-right: 8px;
  }

  .btn-clear-icon {
    position: absolute;
    opacity: 0;
  }

  input {
    flex: 1;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${colorsV2.black100};
    text-overflow: ellipsis;
    margin-right: 0;

    &::placeholder {
      color: ${colorsV2.black60};
    }

    &:disabled {
      color: ${colorsV2.black80};
    }
  }

  &.have-value {
    input {
      padding-right: 20px;
    }

    .btn-clear-icon {
      opacity: 1;
      right: 0;
    }
  }
`;

interface InputContentSearchProps {
  value?: string;
  placeholder?: string;
  onChange?: (e?: any) => void;
  onEnter?: (e?: any) => void;
  onClick?: (e?: any) => void;
  onBlur?: (e?: any) => void;
  onClear?: () => void;
  onFocus?: (e?: any) => void;
  defaultValue?: string;
}

export const InputContentSearch = React.forwardRef<HTMLInputElement, InputContentSearchProps>(
  (props, ref) => {
    const {
      value,
      placeholder = 'Search',
      onEnter,
      onChange,
      onClick,
      onBlur,
      onClear,
      onFocus,
      defaultValue = undefined,
    } = props;
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [inputValue, setInputValue] = React.useState(defaultValue);
    React.useImperativeHandle(ref, () => inputRef.current);

    return (
      <Container
        className={cl('input-content-search', {
          'have-value': inputValue?.length > 0,
        })}
        onClick={onClick}
      >
        <IconCourseSearch size={18} color="black40"/>
        <input
          defaultValue={defaultValue}
          className="input-search"
          ref={inputRef}
          type="search"
          value={value}
          placeholder={placeholder}
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') {
              onEnter?.(e);
            }
          }}
          onChange={(e) => {
            onChange?.(e);
            setInputValue(e.target.value);
          }}
          onBlur={onBlur}
          onFocus={onFocus}
        />
        <ButtonIcon
          className="btn-clear-icon"
          onClick={() => {
            inputRef.current.value = '';
            inputRef.current.focus();
            onClear?.();
            setInputValue('');
          }}
        >
          <IconOtherClose size={16} color="black40"/>
        </ButtonIcon>
      </Container>
    );
  },
);
